import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CoffeeIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M11.5 1a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5h.5a1 1 0 0 1 1 1v.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V3a1 1 0 0 1 1-1h.5a.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5h7Z"
		></path>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			fill="currentColor"
			d="M3.12 5.598A.5.5 0 0 1 3.61 5h8.78a.5.5 0 0 1 .49.598l-1.72 8.598a1 1 0 0 1-.98.804H5.82a1 1 0 0 1-.98-.804L3.12 5.598ZM10 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
		></path>
	</svg>
))
